/**
 * Returns true when the current pathname is, or is nested under, any of the
 * given subsection paths. Shared predicate used by collapsible nav subsections.
 */
export const isOnSubsectionPath = (
    pathname: string,
    paths: string[],
): boolean =>
    paths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
